// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Organization Tree Styles */
.organization-tree {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  height: 100%;
  overflow-y: auto;
}

.tree-header {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.tree-header h3 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.tree-summary {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.summary-item {
  font-size: 14px;
  color: #666;
}

.summary-item strong {
  color: #333;
  font-weight: 600;
}

.tree-content {
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.tree-empty {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.tree-empty p {
  margin: 0;
  font-style: italic;
}

.tree-nodes {
  space-y: 4px;
}

/* Tree Node Styles */
.tree-node {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
  gap: 8px;
}

.tree-node:hover {
  background-color: #f8f9fa;
}

.tree-icon {
  font-size: 16px;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}

.node-label {
  flex: 1 1;
  font-weight: 500;
  color: #333;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.node-count {
  font-size: 12px;
  color: #666;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 10px;
  flex-shrink: 0;
}

.expand-icon {
  font-size: 12px;
  color: #999;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

/* Agency Level */
.tree-agency {
  margin-bottom: 8px;
}

.agency-node {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  border: none;
}

.agency-node:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.agency-node .node-count {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.agency-node .expand-icon {
  color: rgba(255, 255, 255, 0.8);
}

/* Project Level */
.tree-project {
  margin-left: 20px;
  margin-bottom: 4px;
}

.project-node {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  font-weight: 500;
}

.project-node:hover {
  background: linear-gradient(135deg, #3d8bfe 0%, #00d4fe 100%);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
}

.project-node .node-count {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.project-node .expand-icon {
  color: rgba(255, 255, 255, 0.8);
}

/* Contractor Level */
.tree-contractor {
  margin-left: 40px;
  margin-bottom: 4px;
}

.contractor-node {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  font-weight: 500;
}

.contractor-node:hover {
  background: linear-gradient(135deg, #0f8a7e 0%, #32d96b 100%);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
}

.contractor-node .node-count {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.contractor-node .expand-icon {
  color: rgba(255, 255, 255, 0.8);
}

/* Payroll Period Level */
.tree-period {
  margin-left: 60px;
  margin-bottom: 4px;
}

.period-node {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
  color: #8b4513;
  font-weight: 500;
  border: 1px solid rgba(252, 182, 159, 0.3);
}

.period-node:hover {
  background: linear-gradient(135deg, #fce4d0 0%, #f9a88d 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.period-node .node-count {
  background: rgba(139, 69, 19, 0.1);
  color: #8b4513;
}

.period-node .expand-icon {
  color: rgba(139, 69, 19, 0.6);
}

/* Review Items */
.tree-review {
  margin-left: 80px;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.tree-review:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: translateX(4px);
}

.tree-review.selected {
  background: #e3f2fd;
  border-color: #2196f3;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);
}

.review-content {
  flex: 1 1;
  min-width: 0;
}

.review-actions {
  flex-shrink: 0;
}

.review-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.review-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-status {
  font-size: 10px;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.review-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.review-id {
  font-size: 11px;
  color: #666;
  font-family: monospace;
}

.review-date {
  font-size: 11px;
  color: #666;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.action-btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
  min-width: 50px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.action-btn:active {
  transform: translateY(0);
}

.preview-btn {
  background-color: #17a2b8;
  color: white;
}

.preview-btn:hover {
  background-color: #138496;
}

.edit-btn {
  background-color: #ffc107;
  color: #212529;
}

.edit-btn:hover {
  background-color: #e0a800;
}

.download-btn {
  background-color: #28a745;
  color: white;
}

.download-btn:hover {
  background-color: #218838;
}

.audit-btn {
  background-color: #6f42c1;
  color: white;
}

.audit-btn:hover {
  background-color: #5a2d91;
}

/* Tree Children Animation */
.tree-children {
  overflow: hidden;
  animation: expandTree 0.3s ease-out;
}

@keyframes expandTree {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 1000px;
  }
}

/* Scrollbar Styling */
.tree-content::-webkit-scrollbar {
  width: 6px;
}

.tree-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.tree-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.tree-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .organization-tree {
    padding: 12px;
  }
  
  .tree-summary {
    flex-direction: column;
    gap: 8px;
  }
  
  .tree-review {
    margin-left: 60px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .tree-period {
    margin-left: 40px;
  }
  
  .tree-contractor {
    margin-left: 20px;
  }
  
  .tree-project {
    margin-left: 10px;
  }
  
  .node-label {
    font-size: 13px;
  }
  
  .review-title {
    font-size: 12px;
  }
  
  .action-buttons {
    gap: 2px;
  }
  
  .action-btn {
    font-size: 9px;
    padding: 3px 6px;
    min-width: 40px;
  }
}

/* Focus States for Accessibility */
.tree-node:focus {
  outline: 2px solid #2196f3;
  outline-offset: 2px;
}

.tree-review:focus {
  outline: 2px solid #2196f3;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/OrganizationTree.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Organization Tree Styles */\n.organization-tree {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 16px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.tree-header {\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n}\n\n.tree-header h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.tree-summary {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.summary-item {\n  font-size: 14px;\n  color: #666;\n}\n\n.summary-item strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.tree-content {\n  overflow-y: auto;\n  max-height: calc(100vh - 200px);\n}\n\n.tree-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.tree-empty p {\n  margin: 0;\n  font-style: italic;\n}\n\n.tree-nodes {\n  space-y: 4px;\n}\n\n/* Tree Node Styles */\n.tree-node {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  gap: 8px;\n}\n\n.tree-node:hover {\n  background-color: #f8f9fa;\n}\n\n.tree-icon {\n  font-size: 16px;\n  width: 20px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.node-label {\n  flex: 1;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.node-count {\n  font-size: 12px;\n  color: #666;\n  background: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n\n.expand-icon {\n  font-size: 12px;\n  color: #999;\n  width: 16px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/* Agency Level */\n.tree-agency {\n  margin-bottom: 8px;\n}\n\n.agency-node {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-weight: 600;\n  border: none;\n}\n\n.agency-node:hover {\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.agency-node .node-count {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.agency-node .expand-icon {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Project Level */\n.tree-project {\n  margin-left: 20px;\n  margin-bottom: 4px;\n}\n\n.project-node {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  color: white;\n  font-weight: 500;\n}\n\n.project-node:hover {\n  background: linear-gradient(135deg, #3d8bfe 0%, #00d4fe 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);\n}\n\n.project-node .node-count {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.project-node .expand-icon {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Contractor Level */\n.tree-contractor {\n  margin-left: 40px;\n  margin-bottom: 4px;\n}\n\n.contractor-node {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n  font-weight: 500;\n}\n\n.contractor-node:hover {\n  background: linear-gradient(135deg, #0f8a7e 0%, #32d96b 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);\n}\n\n.contractor-node .node-count {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.contractor-node .expand-icon {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Payroll Period Level */\n.tree-period {\n  margin-left: 60px;\n  margin-bottom: 4px;\n}\n\n.period-node {\n  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);\n  color: #8b4513;\n  font-weight: 500;\n  border: 1px solid rgba(252, 182, 159, 0.3);\n}\n\n.period-node:hover {\n  background: linear-gradient(135deg, #fce4d0 0%, #f9a88d 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.period-node .node-count {\n  background: rgba(139, 69, 19, 0.1);\n  color: #8b4513;\n}\n\n.period-node .expand-icon {\n  color: rgba(139, 69, 19, 0.6);\n}\n\n/* Review Items */\n.tree-review {\n  margin-left: 80px;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin-bottom: 2px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.tree-review:hover {\n  background: #e9ecef;\n  border-color: #dee2e6;\n  transform: translateX(4px);\n}\n\n.tree-review.selected {\n  background: #e3f2fd;\n  border-color: #2196f3;\n  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);\n}\n\n.review-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.review-actions {\n  flex-shrink: 0;\n}\n\n.review-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.review-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.review-status {\n  font-size: 10px;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n\n.review-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.review-id {\n  font-size: 11px;\n  color: #666;\n  font-family: monospace;\n}\n\n.review-date {\n  font-size: 11px;\n  color: #666;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1;\n  min-width: 50px;\n}\n\n.action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.action-btn:active {\n  transform: translateY(0);\n}\n\n.preview-btn {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.preview-btn:hover {\n  background-color: #138496;\n}\n\n.edit-btn {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.edit-btn:hover {\n  background-color: #e0a800;\n}\n\n.download-btn {\n  background-color: #28a745;\n  color: white;\n}\n\n.download-btn:hover {\n  background-color: #218838;\n}\n\n.audit-btn {\n  background-color: #6f42c1;\n  color: white;\n}\n\n.audit-btn:hover {\n  background-color: #5a2d91;\n}\n\n/* Tree Children Animation */\n.tree-children {\n  overflow: hidden;\n  animation: expandTree 0.3s ease-out;\n}\n\n@keyframes expandTree {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 1000px;\n  }\n}\n\n/* Scrollbar Styling */\n.tree-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.tree-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.tree-content::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.tree-content::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .organization-tree {\n    padding: 12px;\n  }\n  \n  .tree-summary {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .tree-review {\n    margin-left: 60px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .tree-period {\n    margin-left: 40px;\n  }\n  \n  .tree-contractor {\n    margin-left: 20px;\n  }\n  \n  .tree-project {\n    margin-left: 10px;\n  }\n  \n  .node-label {\n    font-size: 13px;\n  }\n  \n  .review-title {\n    font-size: 12px;\n  }\n  \n  .action-buttons {\n    gap: 2px;\n  }\n  \n  .action-btn {\n    font-size: 9px;\n    padding: 3px 6px;\n    min-width: 40px;\n  }\n}\n\n/* Focus States for Accessibility */\n.tree-node:focus {\n  outline: 2px solid #2196f3;\n  outline-offset: 2px;\n}\n\n.tree-review:focus {\n  outline: 2px solid #2196f3;\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
